import { SearchFilter } from "~/components/search-filter"

interface Props {
  value: string
  onChange: (value: string) => void
  isPending?: boolean
}

export function ChatFilter({ value, onChange, isPending }: Props) {
  return <SearchFilter value={value} onChange={onChange} placeholder="Поиск чатов..." isPending={isPending} />
}
